import React from "react";
import { Helmet } from "react-helmet-async";

const PrivacyPolicyPage = () => {
  const policy = [
    {
      header: "1. Загальні положення",
      text: "Даною Політикою конфіденційності (далі – Політика), Ви надаєте згоду на обробку Ваших персональних даних з метою забезпечення рольового доступу, підготовки статистичної, адміністративної та іншої інформації з питань професійного навчання. Перед використанням Порталу уважно ознайомтесь з Вашими правами та обов’язками щодо обробки персональних даних, які зазначені в статті 8 Закону України «Про захист персональних даних», даною Політикою, а також висловіть свою повну згоду з її умовами.",
    },
    {
      header: "2. Збір та використання персональних даних",
      text: "Збір персональних даних здійснюється виключно за Вашим свідомим та добровільним рішенням як суб’єкта персональних даних для використання функціональних можливостей Порталу та відповідно до сформульованої в цій Політиці мети обробки персональних даних. Масштаби і тип збору та використання Ваших персональних даних різняться залежно від того, в якій ролі Ви плануєте використовувати функціональні можливості Порталу. Здійснюючи залежно від обраної Вами ролі реєстрацію на Порталі та заповнюючи дані особистого облікового запису Ви надаєте наступні дані: ПІБ, дата народження, стать, або інші ідентифікаційні дані, номер телефону та e-mail; відомості, що стосуються Вашої професійної діяльності: місце роботи, посада, категорія посади, спеціальність, кваліфікація, науковий ступінь, вчене звання тощо; при подальшому використанні Порталу автоматично здійснюється збір інформації про що містяться в запитах форм зворотного зв’язку / електронних повідомленнях.",
    },
    {
      header: "3. Мета збору, обробки та використання персональних даних",
      text: "Збір, обробка та використання персональних даних здійснюється з метою: забезпечення рольового доступу, зокрема: реєстрації суб’єктів Порталу; організації електронної взаємодії суб’єктів Порталу через особисті кабінети; узагальнення та систематизації реєстрів та структурованих даних, зокрема: формування переліку; моніторинг, узагальнення та аналіз статистичних даних, що формуються суб’єктами Порталу в результаті його використання. Персональні дані зберігаються на строк не більше, ніж це необхідно відповідно до мети їх збору, обробки та використання або до моменту припинення Вами використання Порталу шляхом видалення свого облікового запису на Порталі.",
    },
    {
      header: "4. Доступ до персональних даних",
      text: "Повний доступ до персональних даних зареєстрованих суб’єктів Порталу надано уповноваженій особі адміністратора Порталу.",
    },
    {
      header: "5. Передача персональних даних третім особам",
      text: "Адміністратор Порталу 210polk.mil.gov.ua не передає та не розголошує персональні дані, які отримує від зареєстрованих суб’єктів Порталу, третім особам. Розкриття персональних даних можливе у випадках, визначених чинним законодавством України, а також у випадку залучення третіх сторін, що надають технічну підтримку та/або послуги щодо удосконалення Порталу на умовах договору та за умови не розголошення персональних даних. Портал може містити гіперпосилання на сторонні веб-сайти та інші ресурси в мережі Інтернет третіх осіб. Ресурси третіх осіб можуть регулюватися власними правилами користування та конфіденційності. Ресурси третіх осіб та їх контент не перевіряються нами на відповідність вимогам (достовірності, повноти, законності тощо). Ми не несемо відповідальності за будь-яку інформацію, матеріали, розміщені на ресурсах третіх осіб.",
    },
    {
      header: "6. Захист персональних даних",
      text: "Адміністратор Порталу вживає необхідних процедурних і технічних заходів щодо захисту Ваших персональних даних від їх втрати, неправомірного доступу до них або їх розповсюдження на Порталі.",
    },
    {
      header: "7. Зміни до умов Політики",
      text: "Адміністратор Порталу може змінювати цю Політику, щоб вона точно відображала методи збору, обробки, використання, доступу та захисту персональних даних. Відповідно Ви повинні переглядати цю Політику періодично. Коли адміністратор Порталу змінює цю Політику, він оновлює дату «останньої зміни» у верхній частині цієї Політики. Зміни до цієї Політики є ефективними, коли вони опубліковані.",
    },
    {
      header: "8. Ваші права",
      text: "Зареєструвавшись на Порталі, Ви маєте право: отримувати інформацію про джерела збору та місце збереження своїх персональних даних, мету їх обробки; отримувати інформацію про умови надання доступу до персональних даних, зокрема інформацію про третіх осіб, яким передаються Ваші персональні дані; отримувати не пізніше тридцяти календарних днів з дня надходження запиту (крім випадків, передбачених Законом України «Про захист персональних даних») інформацію щодо обробки та використання Ваших персональних даних; пред’являти вмотивовану вимогу володільцю персональних даних із запереченням щодо обробки Ваших персональних даних; звертатися із скаргами щодо опрацювання Ваших персональних даних володільцем чи розпорядником персональних даних до Уповноваженого Верховної ради України з прав людини або до суду; застосовувати засоби правового захисту в разі порушення законодавства про захист персональних даних; відкликати згоду на обробку Ваших персональних даних.",
    },
    {
      header: "9. Місце знаходження персональних даних",
      text: "Володільцем та розпорядником персональних даних є 210 ОШП.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>210 Окремий Штурмовий Полк | Політика конфіденційності</title>
        <meta name="description"
              content="Політика конфіденційності"/>
      </Helmet>
      <div style={styles.formWrapper}>
        <div style={{...styles.formWrapper, backgroundColor: "var(--olive)"}}>
          <div style={styles.headerContainer}>
            <h1 style={styles.formHeader}>Політика конфіденційності</h1>
          </div>
        </div>
        <div style={styles.formContainer}>
          {policy.map((item) => (
            <div style={styles.policyBlock}>
              <h2 style={styles.policyHeader}>{item.header}</h2>
              <p style={styles.policyText}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  formWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "var(--white)",
    overflow: "hidden",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    margin: "0 auto",
    paddingTop: "4rem",
    paddingBottom: "2rem",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    margin: "0 auto",
    paddingTop: "2rem",
    paddingBottom: "4rem",
    gap: "2rem",
  },
  formHeader: {
    fontSize: "min(3rem,10vw)",
    fontWeight: "bold",
    color: "var(--dark-grey)",
    marginBottom: "1rem",
  },
  policyBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  policyHeader: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "var(--dark-grey)",
  },
  policyText: {
    fontSize: "1.2rem",
    color: "var(--dark-grey)",
  }
};

export default PrivacyPolicyPage;
